<template>
  <div class="common-box border-t0">
    <el-row class="row-one">
      <span class="row-one-title">私募交易记录详情</span>
      <Reback class="row-one-fr" @click.native="returnClick"></Reback>
      <span class="row-one-fr" @click="detailsClick">查看资产详情</span>
    </el-row>
    <!-- 详情 -->
    <section class="xDetail">
      <p class="xDetail-title">{{message.name}}</p>
      <p class="xDetail-title1">{{message.money}}</p>
      <ul class="xDetail-stepsone" v-show="false">
        <li class="xDetail-stepsone-li">
          <div class="xDetail-stepsone-li-head">
            <img src="../../../assets/images/20210316_dg.png" alt="" width="20">
            <div class="xDetail-stepsone-li-head-shu"></div>
          </div>
          <div class="xDetail-stepsone-li-main">02-18日星期四确认份额，开始计算收益</div>
        </li>
        <li class="xDetail-stepsone-li">
          <div class="xDetail-stepsone-li-head">
            <img src="../../../assets/images/20210316_sy.png" alt="" width="20">
            <div class="xDetail-stepsone-li-head-shu"></div>
          </div>
          <div class="xDetail-stepsone-li-main">02-19日星期五查看收益</div>
        </li>
        <li class="xDetail-stepsone-li">
          <div class="xDetail-stepsone-li-head">
            <img src="../../../assets/images/20210316_sy.png" alt="" width="20">
            <div class="xDetail-stepsone-li-head-shu"></div>
          </div>
          <div class="xDetail-stepsone-li-main">02-19日星期五查看收益</div>
        </li>
      </ul>
      <hr class="xDetail-hr">
      <p class="xDetail-subtit1">{{message.type == "买入"?'购买':'卖出'}}</p>
      <ul class="xDetail-ul">
        <li class="xDetail-ul-li"><span>申请时间：</span><span>{{message.time}}</span></li>
        <li class="xDetail-ul-li"><span>所属开放日：</span><span>{{message.OPERDATE?this.$commonJs.getDateStrHg(message.OPERDATE):'--' }}</span></li>
        <li class="xDetail-ul-li"><span>业务类型：</span><span>{{message.type1}}</span></li>
        <li class="xDetail-ul-li"><span>支付方式：</span><span>银行转账划款支付</span></li>
        <li class="xDetail-ul-li"><span>关联银行卡：</span><span>{{message.account}}</span></li>
        <li class="xDetail-ul-li"><span>申请金额：</span><span>{{message.money}}</span></li>
        <li class="xDetail-ul-li" v-if="message.CONFIRMEDVOL || message.deal_portion"><span>确认份额：</span><span>{{message.CONFIRMEDVOL?message.CONFIRMEDVOL+'份':message.deal_portion+'份'}}</span></li>
        <li class="xDetail-ul-li" v-else><span>确认份额：</span><span>0份</span></li>
        <li class="xDetail-ul-li"><span>认/申购费：</span><span>{{message.Charge?message.Charge+'元':message.CHARGE +'元'}}</span></li>
        <li class="xDetail-ul-li" v-if="message.NAV"><span>成交净值：</span><span>{{message.NAV == '--'?message.NAV : parseFloat(message.NAV).toFixed(4)}}</span></li>
        <li class="xDetail-ul-li" v-else-if="message.deal_netValue"><span>成交净值：</span><span>{{message.deal_netValue == '--'?message.deal_netValue:parseFloat(message.deal_netValue).toFixed(4)}}</span></li>
        <li class="xDetail-ul-li" v-else><span>成交净值：</span><span>0.0000</span></li>
        <li class="xDetail-ul-li"><span>交易状态：</span><span>{{message.status}}</span></li>
      </ul>
      <hr class="xDetail-hr">
      <ul class="xDetail-ul">
        <li class="xDetail-ul-li"><span>订单编号</span><span>{{message.APPSHEETSERIALNO?message.APPSHEETSERIALNO:message.OrderNum}}</span></li>
      </ul>
      <div class="xDetail-footer">
        <el-button type="normal" @click="contractClick">查看合同</el-button>
        <el-button type="normal" @click="getVoucher">转账凭证</el-button>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  data () {
    return {
      message: '',

    }
  },
  created () {
    this.message = this.$route.params.message
    // console.log(this.message);
  },
  methods: {
    returnClick () {
      this.$router.push({
        name: 'privateRecord'
      })
    },
    detailsClick () {
      this.$router.push({
        name: 'privateAssetsMessage'
      })
    },
    contractClick () {
      this.$router.push({
        name: 'contract',
        params: {
          message: this.message
        }
      })
    },
    // 转账凭证
    getVoucher () {
      let APPSHEETSERIALNO = this.message.APPSHEETSERIALNO ? this.message.APPSHEETSERIALNO : this.message.OrderNum
      this.$http.post(this.$apiPath.privateView, {
        orderNum: APPSHEETSERIALNO
      }).then(res => {
        // console.log(res);
        if (res.status !== 200 && res.data.code !== '200') return
        if (res.data.data.picture != "" && res.data.data.picture != null) {//有图片
          if (res.data.data.picture.substr(0, 4) == 'http') {
            window.open(res.data.data.picture);
          } else {
            window.open('https://www.myfund.com/' + res.data.data.picture);
          }
        } else {
          this.$message.error('暂无凭证')
        }

      })
    }
  }
}
</script>

<style scoped>
</style>